export default __webpack_public_path__ + "static/woman-e16c79f35a84158910ed23b0ec43e18f.webp";